import { render, staticRenderFns } from "./NonContiguousBooking.vue?vue&type=template&id=2c25242d&scoped=true&"
import script from "./NonContiguousBooking.vue?vue&type=script&lang=js&"
export * from "./NonContiguousBooking.vue?vue&type=script&lang=js&"
import style0 from "./NonContiguousBooking.vue?vue&type=style&index=0&id=2c25242d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25242d",
  null
  
)

export default component.exports